const global = globalThis || void 0 || self;
export {
  global as g
};
//# sourceMappingURL=index-703c58ee.mjs.map
